import { Vue, Component, Prop } from "vue-property-decorator";
import type { CreateElement, VNode } from "vue";
import style from "./style.vue";
import { noop } from "@/util";
import { IPSService } from "@/services/ipsServices";

export const ImgBasePath = "../../../../static/img";
// 装修的颜色枚举
export enum RenovationColor {
	redOrangeWhite = 1,
	redBlockWhite,
	yellowBlockWhite,
	redGreyBlock,
	greenGreyBlock,
	yellowGreyBlock,
}
// 装修的颜色列表
export const RenovationColorList: { [key in RenovationColor]: string[] } = {
	[RenovationColor.redOrangeWhite]: ["#FF4444", "#FF8855", "#fff"],
	[RenovationColor.redBlockWhite]: ["#FF4444", "#595959", "#fff"],
	[RenovationColor.yellowBlockWhite]: ["#FCC600", "#595959", "#fff"],
	[RenovationColor.redGreyBlock]: ["#FF4444", "#595959", "#000"],
	[RenovationColor.greenGreyBlock]: ["#09BB07", "#595959", "#000"],
	[RenovationColor.yellowGreyBlock]: ["#FCC600", "#595959", "#000"],
};

export const RenovationImgList: { [key in RenovationColor]: string } = {
	[RenovationColor.redOrangeWhite]: "https://ssl-picture.tenyun.runsasoft.com/a0be83a0-8605-11ea-b4bd-4d249f0b4c0a",
	[RenovationColor.redBlockWhite]: "https://ssl-picture.tenyun.runsasoft.com/a29a4880-8605-11ea-b4bd-4d249f0b4c0a",
	[RenovationColor.yellowBlockWhite]: "https://ssl-picture.tenyun.runsasoft.com/9e8de800-8605-11ea-b4bd-4d249f0b4c0a",
	[RenovationColor.redGreyBlock]: "https://ssl-picture.tenyun.runsasoft.com/a6b66070-8605-11ea-b4bd-4d249f0b4c0a",
	[RenovationColor.greenGreyBlock]: "https://ssl-picture.tenyun.runsasoft.com/a8909eb0-8605-11ea-b4bd-4d249f0b4c0a",
	[RenovationColor.yellowGreyBlock]: "https://ssl-picture.tenyun.runsasoft.com/a472b200-8605-11ea-b4bd-4d249f0b4c0a",
};

@Component({
	mixins: [style],
})
export default class StyleConfig extends Vue {
	radioSelect = 1;

	preRadioSelect = 1;

	sgId;

	/**
	 *
	 * @param radioValue number
	 */
	handleRadioGroupChange(radioValue: number) {
		console.log(radioValue);
	}

	themeChange(val) {
		this.$confirm("切换风格后，店铺展示配置-个人中心中的图标导航图标将置位默认值，是否确认更改？", "提示", {
			confirmButtonText: "确定",
			showCancelButton: true,
			type: "warning",
		})
			.then((result) => {
				if (result === "confirm") {
					this.radioSelect = val;
					this.preRadioSelect = val;
				}
			})
			.catch((cancel) => {
				if (cancel === "cancel") {
					this.radioSelect = this.preRadioSelect;
				}
			});
	}

	save() {
		IPSService.decorationThemeColorSave({ postParams: { sgId: this.sgId, themeCode: this.radioSelect } }).then((res) => {
			if (res && res.result) {
				localStorage.setItem("themeCode", `${this.radioSelect}`);
				this.$message.success("保存成功");
			}
		});
	}

	mounted() {
		this.sgId = Number.parseInt(this.$route.params.id);
		IPSService.decorationThemeColorInfo({
			postParams: {
				sgId: this.sgId,
			},
		}).then(
			(res: ItemObject) => {
				this.radioSelect = +res.themeCode;
				this.preRadioSelect = this.radioSelect;
			},
			() => {
				this.$message.error("获取主题失败");
			},
		);
	}

	render(h: CreateElement): VNode {
		return (
			<div class="style-config-wrapper">
				<div class="wrapper">
					<el-radio-group v-model={this.radioSelect} class="radio-wrap" onChange={this.themeChange.bind(this)}>
						{Object.keys(RenovationColorList).map((i) => {
							return (
								<el-radio label={+i} key={`${i}radio`} class="radio">
									{RenovationColorList[i].map((val) => {
										return <span class="color-item" style={{ backgroundColor: val, border: val === "#fff" ? "1px solid #eee" : "none" }} />;
									})}
								</el-radio>
							);
						})}
					</el-radio-group>

					<div class="style-img">
						<img src={RenovationImgList[this.radioSelect]} alt="" class="img" />
					</div>
				</div>

				<div class="bottomWrapper">
					<el-button size="medium" type="primary" onClick={this.save.bind(this)}>
						保存
					</el-button>
				</div>
			</div>
		);
	}
}
